<template>
  <div class="app-header d-flex jc-sb col-center">
    <div class="d-flex col-center">
      <div class="d-flex col-center" @click="$router.push({ name: 'index' })">
        <img class="mx-2 logo" src="@/assets/images/index/logo.png">
      </div>
      <div class="d-flex col-center">
        <navbar />
      </div>
    </div>
    <div class="right-div d-flex col-center">
      <div class="project">
        <el-select
          v-model="value"
          size="small"
          placeholder="请选择"
          @change="chooseProject"
        >
          <el-option
            v-for="item in options"
            :key="item.IdStr"
            :label="item.ModelName"
            :value="item.IdStr"
          />
        </el-select>
      </div>
      <div class="time">
        <div class="timestamp number-font">{{ time }}</div>
        <div class="date">
          <span>{{ date }}</span>
          <span>{{ week }}</span>
        </div>
      </div>
      <div class="user">
        <el-dropdown @command="handleCommand">
          <img class="user-icon" src="@/assets/images/index/user.png">
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="quit">
              <div style="width: 100px; text-align: center">退出</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div style="color: #ffffff" class="ml-2">{{ userName }}</div>
    </div>
    <el-dialog
      title="新告警"
      :visible.sync="warningShow"
      width="90%"
      :modal="false"
    >
      <el-table
        id="exportTable"
        ref="multipleTable"
        size="small"
        stripe
        height="400"
        :data="tableData"
        highlight-current-row
        :before-close="handleClose"
        @row-click="GoworkOrderDetail"
      >
        <el-table-column type="index" label="#" />
        <el-table-column
          prop="EquipmentName"
          label="告警设备"
          min-width="250"
        />
        <el-table-column prop="ProjectName" min-width="120" label="项目名称" />
        <el-table-column prop="State" label="告警状态" min-width="100">
          <template slot-scope="scope">{{
            typeName(scope.row.State)
          }}</template>
        </el-table-column>
        <el-table-column prop="ReadStatusName" label="读取状态" width="80" />
        <el-table-column prop="RuleClassName" label="告警类型" min-width="160" />
        <el-table-column prop="StationName" label="所属站点" />
        <el-table-column prop="MarkTime" label="告警时间" min-width="160" />
        <el-table-column prop="Address" label="告警地点" />
        <el-table-column label="操作" align="center" width="90">
          <template slot-scope="scope">
            <button-option icon="el-icon-check" skin="success" title="已读" @click.native="check(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="close()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Navbar from './Navbar/index'
import { BASE_URL } from '@/utils/request'
import { formatDate } from '@/utils/utils'
import Speech from 'speak-tts'
import connectServer from '@/utils/signlar'
export default {
  name: 'AppHeader',
  components: {
    Navbar
  },
  data() {
    return {
      date: '',
      time: '',
      week: '',
      timer: null,
      options: this.$store.getters.projectList,
      value: this.$store.getters.selectProject.IdStr,
      mini: false,
      connectionSignalR: null,
      intervalId: 0,
      dialogVisible: false,
      baseUrl: BASE_URL,
      formatDate: null,
      isCollapse: true,
      dateTime: formatDate(new Date(), 'yyyy/MM/dd HH:mm:ss'),
      info: {},
      warnCount: 0,
      warningShow: false,
      tableData: []
    }
  },
  computed: {
    selectProject() {
      return this.$store.getters.selectProject
    },
    userName() {
      return this.$store.getters.userName
    },
    mark() {
      return this.$store.getters.mark
    },
    typeName() {
      return function(val) {
        switch (val) {
          case 0:
            return '未处理'
          case 1:
            return '处理中'
          case 2:
            return '已处理'
          case 3:
            return '已忽略'
        }
      }
    }
  },
  created() {
    if (!this.$store.getters.projectList) {
      this.getProjectTree()
    }
    this.speech = new Speech() // will throw an exception if not browser supported
    if (this.speech.hasBrowserSupport()) { // returns a boolean
      console.log('speech synthesis supported')
    }
    this.speech.init({
      lang: 'zh-CN',
      splitSentences: true
    })
    const that = this
    connectServer(this.mark).then((conn) => {
      conn.received((data) => {
        console.log(data)
        if (data.A[0].WarnGrade === 'WarnGrade_1' || data.A[0].WarnGrade === 'WarnGrade_2') {
          that.warningShow = true
          that.tableData = data.A.concat(that.tableData)
          that.speech.speak({
            text: `有新告警，告警设备${data.A[0].EquipmentName}，告警类型${data.A[0].RuleClassName}`
          }).then(() => {
            console.log('Success !')
          }).catch((e) => {
            console.error('An error occurred :', e)
          })
        }
      })
    })
  },
  mounted() {
    this.autoSetScale() // 进页面先执行一次页面高度和宽度计算然后赋值
    window.addEventListener(
      'resize',
      () => {
        this.autoSetScale()
      },
      false
    )
    this.timer = setInterval(this.getCurDate, 1000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    autoSetScale() {
      const width = window.innerWidth
      if (width < 1600) {
        this.mini = true
      } else {
        this.mini = false
      }
    },
    getCurDate() {
      var d = new Date()
      var week
      switch (d.getDay()) {
        case 1:
          week = '星期一'
          break
        case 2:
          week = '星期二'
          break
        case 3:
          week = '星期三'
          break
        case 4:
          week = '星期四'
          break
        case 5:
          week = '星期五'
          break
        case 6:
          week = '星期六'
          break
        default:
          week = '星期天'
      }
      var years = d.getFullYear()
      var month = this.add_zero(d.getMonth() + 1)
      var days = this.add_zero(d.getDate())
      var hours = this.add_zero(d.getHours())
      var minutes = this.add_zero(d.getMinutes())
      this.date = years + '.' + month + '.' + days
      this.time = hours + ':' + minutes
      this.week = week
    },
    add_zero(temp) {
      if (temp < 10) return '0' + temp
      else return temp
    },
    handleCommand(command) {
      if (command === 'quit') {
        this.$store.dispatch('user/logout')
        this.$router.push('/login')
        this.msgSuccess('退出成功！')
        // 清空树数据
        this.$store.dispatch('projects/projectList', null)
        this.$store.dispatch('projects/setSelectProject', null)
        this.$store.dispatch('projects/setSelectPds', null)
        this.$store.dispatch('projects/setSelectNode', null)
      }
    },
    chooseProject(val) {
      const project = this.options.find((e) => {
        return e.IdStr === val
      })
      this.$store.dispatch('projects/setSelectProject', project)
      this.$store.dispatch('GetCommomTree')
    },
    getProjectTree() {
      this.$store.dispatch('GetProjectTree').then((res) => {
        this.$store.dispatch('projects/projectList', res.Data_Obj)
        this.options = res.Data_Obj
        const o = res.Data_Obj.find(e => {
          return e.IdStr === 'NTExRERCNEJDNDA4QjI0MA'
        })
        console.log(o)
        if (o) {
          this.value = o.IdStr
          this.$store.dispatch('projects/setSelectProject', o)
        } else {
          this.value = res.Data_Obj[0].IdStr
          this.$store.dispatch('projects/setSelectProject', res.Data_Obj[0])
        }
      })
    },
    handleClose(done) {
      this.tableData = []
      done()
    },
    GoworkOrderDetail(rowindex) {
      const params = {
        WRIDs: rowindex.TabID
      }
      this.$store.dispatch('UpdatereadStatus', params).then(res => {
        this.warningShow = false
        this.$router.push({
          path: '/warning/allWarning',
          query: {
            id: rowindex.TabID
          }
        })
      })
    },
    check(rowindex) {
      const params = {
        WRIDs: rowindex.TabID
      }
      this.$store.dispatch('UpdateWarningStateByIds', params).then(res => {
        this.msgSuccess('操作成功！')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.app-header {
  display: flex;
  align-items: center;
  .project {
    .el-select {
      .el-input {
        .el-input__inner {
          background: rgba(0, 0, 0, 0.2);
          color: #ffffff;
          border: 0.5px solid #989898;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.app-header {
  // min-width: $minWidth;
  width: vw(1920);
  // line-height: 50px;
  height: $headerHeight;
  z-index: 2000;
  color: $headerColor;
  > div {
    // padding-top: 10px;
    // height: 70px;
  }
  .mini {
    transform: scale(0.8);
  }
  .mini-left {
    transform-origin: 0% 0%;
  }
  .mini-right {
    transform-origin: 100% 0%;
  }
}
.header-left {
  float: left;
}
.logo {
  height: vw(50);
}
.right-div {
  padding-right: 21px;
  line-height: normal;
  // align-items: flex-end;
  .project {
    height: 100%;
    margin-right: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .time {
    margin-right: 30px;
    .timestamp {
      padding-top: 4px;
      font-size: 24px;
      line-height: 24px;
    }
    .date {
      font-size: 16px;
      letter-spacing: 0.12px;
      min-width: 140px;
      span {
        margin-right: 5px;
        white-space: nowrap;
        word-break: keep-all;
      }
    }
  }
  .user {
    text-align: center;
    .user-icon {
      width: 39px;
      height: 39px;
      margin: 0 auto;
    }
    span {
      display: block;
      line-height: normal;
      white-space: nowrap;
      word-break: keep-all;
    }
  }
}
</style>
